import styled from "styled-components";
import { Link } from "react-router-dom";

import { getColor, getColorWithAlpha, responsive } from "~/helpers/style";

import Button from "~/components/ui/Button";

import marcChapon from "~/assets/png/onboarding-shopify-marc.png";
import shopifyLogo from "~/assets/svg/shopifyImg.svg";

export const Container = styled.div`
  padding: 60px 0;

  ${responsive("mobileL")} {
    padding: 50px 20px;
  }

  ${responsive("tablet")} {
    display: flex;
    flex-direction: row-reverse;
    width: 100%;
    max-width: 800px;
    justify-content: center;
    padding: 20px 20px;
    width: 800px;
    height: 440px;
    background-color: ${getColor("sidebar")};
  }

  a:hover {
    text-decoration: none;
  }
`;

export const LoadingContainer = styled.div`
  height: 100%;
  margin-right: 30px;

  .loading-spinner-container {
    height: 100%;

    ${responsive("tablet")} {
      height: 100%;
      margin-right: 50px;
    }
  }
`;

export const LeftContainer = styled.div`
  order: 1;
  width: 100%;
  align-items: center;
  padding: 25px 10px;
  text-align: center;

  ${responsive("tablet")} {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: center;
    padding-right: 30px;
    padding-left: 18px;
    gap: 17.25px;
    position: relative;
    overflow: hidden;
    text-align: start;
  }
`;

export const RightContainer = styled.div`
  display: none;

  ${responsive("tablet")} {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    padding-left: 30px;
    border-left: solid 1px ${getColorWithAlpha("secondary", 0.1)};
    width: 68%;
  }
`;

export const ShopifyLogo = styled.img.attrs({
  src: shopifyLogo,
  alt: "Shopify logo",
})`
  width: 82px;
`;

export const TimerTextContainer = styled.div`
  align-items: center;
  flex-direction: row;
  justify-content: center;
  display: flex;

  ${responsive("tablet")} {
    justify-content: unset;
    gap: 12px;
    margin-bottom: 0px;
  }

  ${responsive("tablet", true)} {
    gap: 4px;
  }
`;

export const TimerText = styled.p`
  font-family: "Inter Variable";
  font-size: 18px;
  font-style: normal;
  font-weight: 800;
  line-height: 86.5%;
  color: ${getColor("text")};
`;

export const CountdownContainer = styled.div`
  display: flex;
  align-items: center;
  height: 35px;
  border-radius: 8px;
  font-family: Avenir;
  padding: 0 12px;
  background-color: ${getColor("primaryLight")};
  p {
    font-family: Avenir;
  }
  span {
    margin: 0;
    padding: 1px;
    font-family: Avenir;
    font-size: 18px;
    font-style: normal;
    font-weight: 800;
    line-height: 86.6%;

    svg {
      padding: 0;
    }
  }
`;

export const MainTextContainer = styled.div`
  text-align: center;
  font-family: Ubuntu;
  font-size: 23px;
  font-style: normal;
  font-weight: 800;
  line-height: 160%;
  color: ${getColor("text")};
  margin-bottom: 0px;

  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 38px;
  margin-top: 14px;

  ${responsive("tablet")} {
    text-align: start;
    margin-top: 14px;
  }
`;

export const StyledButton = styled(Button)`
  display: flex;
  padding: 11px 58px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-style: normal;
  line-height: 182%;
  border-radius: 6px;
  width: 100%;
  border-color: transparent;
  background-color: ${getColor("greenLight")};
  color: ${getColor("white")};

  font-family: "Inter Variable";
  font-weight: 600;
  line-height: 29.12px;
  margin-top: 16px;

  ${responsive("tablet")} {
    padding: 11px;
    margin-top: unset;
  }
`;

export const StyledLink = styled(Button)`
  padding: 11px 18px;
  width: 100%;
  font-family: "Inter Variable";
  font-size: 16px;
  font-style: normal;
  border-radius: 6px;
  background-color: ${getColorWithAlpha("secondary", 0.1)};
  color: ${getColor("text")};
  z-index: 1;
  margin-top: 10px;
  font-weight: 400;
  line-height: 29.12px;
  transition: filter 0.3s ease;

  ${responsive("tablet")} {
    margin-top: -10px;
  }

  &:hover {
    color: ${getColor("text")};
    filter: brightness(0.4);
  }
`;

export const MarcChaponImage = styled.img.attrs({
  src: marcChapon,
  alt: "Marc Chapon",
})`
  width: 160px;
`;

export const QuoteText = styled.p`
  color: ${getColor("text")};
  text-align: center;
  font-family: "Inter Variable";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 158%;
  margin-top: 7px;
  margin-bottom: 0px;
`;

export const QuoteTextHighlight = styled.span`
  color: ${getColor("greenLight")};
  font-family: "Inter Variable";
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 158%;
`;

export const QuoteAuthor = styled.p`
  color: ${getColorWithAlpha("text", 0.8)};
  text-align: center;
  font-family: "Inter Variable";
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 158%;
  opacity: 0.4;
  margin-bottom: 0px;
`;

export const StyledPrimaryLink = styled(Link)`
  width: 100%;
  cursor: pointer;
  text-decoration: none;
`;

export const CentsText = styled.p`
  margin-top: -15px;
  margin-left: -1px;
  font-family: Avenir;
  font-size: 14px;
  font-weight: 500;
  color: ${getColor("primary")};
  margin-bottom: 0;
`;

export const ValueContainer = styled.div`
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  align-items: center;

  .emoji {
    margin-left: 4px;
  }
`;


export const CentsStoreText = styled(CentsText)`
  color: ${getColorWithAlpha("text", 0.4)};
  font-weight: 700;
`;